import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent, ref } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

export default defineComponent({
  name: "Vote",
  props: {
    satisfied: {
      type: Number,
      default: 0
    },
    dissatisfied: {
      type: Number,
      default: 0
    },
    row: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ["voteSubmit"],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var router = useRouter();
    var id = useRoute().query.id;
    var ishide = ref(false);
    var value = ref(0);
    var radio = [{
      name: "是，处理的很好",
      value: 1
    }, {
      name: "否，还有待提升",
      value: 2
    }];
    var showText = "你觉得本次难事处理的结果？"; //关闭

    function close() {
      ishide.value = false;
      value.value = 0;
    } // 投票


    function submit() {
      return _submit.apply(this, arguments);
    }

    function _submit() {
      _submit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(value.value == 0)) {
                  _context.next = 3;
                  break;
                }

                ElMessage.warning("请选择满意情况");
                return _context.abrupt("return");

              case 3:
                _context.next = 5;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api['setVote']({
                  id: id,
                  manner: value.value
                });

              case 5:
                res = _context.sent;

                if (res.code == 0) {
                  ElMessage.success("投票成功");
                  setTimeout(function () {
                    ishide.value = false;
                    emit("voteSubmit");
                  }, 300);
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _submit.apply(this, arguments);
    }

    return {
      ishide: ishide,
      value: value,
      radio: radio,
      showText: showText,
      close: close,
      submit: submit
    };
  }
});